/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
//import vuetify from './plugins/vuetify';

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale });

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

// import htmlEditButton from "quill-html-edit-button";
Vue.use(VueQuillEditor);

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

import VTooltip from 'v-tooltip';

Vue.use(VTooltip);


import vueMoment from "vue-moment";
Vue.use(vueMoment);

import numeral from "numeral";
import numFormat from "vue-filter-number-format";
Vue.filter("numFormat", numFormat(numeral));

import DataTable from "laravel-vue-datatable";
Vue.use(DataTable);

// Install BootstrapVue
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, { fieldsBagName: "veeFields" });

// Gravatar
import Gravatar from "vue-gravatar";
Vue.component("v-gravatar", Gravatar);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import TreeView from "vue-json-tree-view";
Vue.use(TreeView);

import VueJsonToTable from "vue-json-to-table";
Vue.use(VueJsonToTable);

import VueFormJsonSchema from "vue-form-json-schema";
Vue.component("vue-form-json-schema", VueFormJsonSchema);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// tawk
// import Tawk from "vue-tawk";
// Vue.use(Tawk, {
//   tawkSrc: "https://embed.tawk.to/5fadedcb7279c47e5dcf69ae/default"
// });

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");
var _ = require("lodash");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Vue.filter("soldoutt-field", function(value) {
//   if (!value) return "";
//   value = value.toString();
//   return value.charAt(0).toUpperCase() + value.slice(1);
// });

import './plugins/article-editor/article-editor.min.js';

Vue.component('article-editor', {
  template: '<textarea ref="article" :name="name" :placeholder="placeholder" :value="value" />',
  article: false,
  props: {
      value: {
          default: '',
          type: String
      },
      placeholder: {
          type: String,
          default: null
      },
      name: {
          type: String,
          default: null
      },
      config: {
          default: {},
          type: Object
      }
  },
  mounted() {
      this.init()
  },
  beforeDestroy() {
      this.destroy()
  },
  methods: {
      init () {
          var me = this;
          var subscribe = {
              'editor.change': function(event) {
                  var html = event.get('html');
                  me.handleInput(html);
                  return html
              }
          };

          // extend config
          Vue.set(this.config, 'subscribe', subscribe);

          // call
          var app = ArticleEditor(this.$refs.article, this.config);

          // set instance
          this.article = app;
          this.$parent.article = app;
      },
      destroy () {
          // Call destroy on article to cleanup event handlers
          this.article.stop();

          // unset instance for garbage collection
          this.article = null;
          this.$parent.article = null;
      },
      handleInput (val) {
          this.$emit('input', val);
      }
  }
});


Vue.config.productionTip = false;
new Vue({
  //vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
